/* tslint:disable */
/* eslint-disable */
/**
 * Swagger wiegaaterkoffiehalen
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.3.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type NotificationBody,
    NotificationBodyFromJSON,
    NotificationBodyToJSON,
} from '../models/NotificationBody';

export interface UpdateNotifcationRequest {
    /**
     * 
     */
    accessToken: string;
    /**
     * The ID of the group
     */
    id: string;
    /**
     * 
     */
    notificationBody: NotificationBody;
}

/**
 * 
 */
export class GroupNotificationsApi extends runtime.BaseAPI {

    /**
     * Creates request options for updateNotifcation without sending the request
     */
    async updateNotifcationRequestOpts(requestParameters: UpdateNotifcationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['accessToken'] == null) {
            throw new runtime.RequiredError(
                'accessToken',
                'Required parameter "accessToken" was null or undefined when calling updateNotifcation().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateNotifcation().'
            );
        }

        if (requestParameters['notificationBody'] == null) {
            throw new runtime.RequiredError(
                'notificationBody',
                'Required parameter "notificationBody" was null or undefined when calling updateNotifcation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['accessToken'] != null) {
            headerParameters['access-token'] = String(requestParameters['accessToken']);
        }


        let urlPath = `/groups/{id}/notifications`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NotificationBodyToJSON(requestParameters['notificationBody']),
        };
    }

    /**
     * Turn of / off notifications
     */
    async updateNotifcationRaw(requestParameters: UpdateNotifcationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateNotifcationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Turn of / off notifications
     */
    async updateNotifcation(requestParameters: UpdateNotifcationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateNotifcationRaw(requestParameters, initOverrides);
    }

}
